(() => {
  const root = document.querySelector('[data-cart-builder]');
  if (!root) return;

  const sectionId = root.getAttribute('data-section-id');
  let filter = 'all';
  let busy = false;
  // product handle -> chosen variant id, so picks survive the section re-render after each add
  const packChoice = {};

  const applyFilter = () => {
    root.querySelectorAll('[data-cart-filters] [data-filter]').forEach((btn) => {
      btn.classList.toggle('active', btn.getAttribute('data-filter') === filter);
    });
    root.querySelectorAll('[data-cart-grid] .bundle-product').forEach((card) => {
      card.hidden = filter !== 'all' && card.getAttribute('data-brand') !== filter;
    });
  };

  const selectPack = (card, option) => {
    card.querySelectorAll('[data-pack-option]').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn === option ? 'true' : 'false');
    });
    const add = card.querySelector('[data-add]');
    if (add) add.setAttribute('data-add', option.getAttribute('data-variant-id'));
    const price = card.querySelector('[data-pack-price]');
    if (price) price.textContent = option.getAttribute('data-price');
    const unit = card.querySelector('[data-pack-unit]');
    if (unit) unit.textContent = option.getAttribute('data-unit') || '';
  };

  const applyPackChoices = () => {
    Object.entries(packChoice).forEach(([handle, variantId]) => {
      root.querySelectorAll(`[data-builder-card][data-product="${CSS.escape(handle)}"]`).forEach((card) => {
        const option = card.querySelector(`[data-pack-option][data-variant-id="${variantId}"]`);
        if (option && !option.disabled) selectPack(card, option);
      });
    });
  };

  const showError = (message) => {
    const el = root.querySelector('[data-cart-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  };

  const refreshCartBubble = async () => {
    try {
      const res = await fetch('/?sections=cart-icon-bubble');
      const data = await res.json();
      const target = document.getElementById('cart-icon-bubble');
      if (target && data['cart-icon-bubble']) {
        const doc = new DOMParser().parseFromString(data['cart-icon-bubble'], 'text/html');
        const inner = doc.querySelector('.shopify-section');
        if (inner) target.innerHTML = inner.innerHTML;
      }
    } catch (err) {
      /* non-critical */
    }
  };

  const refreshSection = async () => {
    const res = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-builder]');
    if (next) {
      root.innerHTML = next.innerHTML;
      applyFilter();
      applyPackChoices();
    }
    refreshCartBubble();
  };

  const post = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    }
    return res.json();
  };

  root.addEventListener('click', async (event) => {
    const filterBtn = event.target.closest('[data-filter]');
    if (filterBtn) {
      filter = filterBtn.getAttribute('data-filter');
      applyFilter();
      return;
    }

    const packBtn = event.target.closest('[data-pack-option]');
    if (packBtn) {
      const card = packBtn.closest('[data-builder-card]');
      if (!card || packBtn.disabled) return;
      selectPack(card, packBtn);
      packChoice[card.getAttribute('data-product')] = packBtn.getAttribute('data-variant-id');
      return;
    }

    const addBtn = event.target.closest('[data-add]');
    const lineBtn = event.target.closest('[data-line]');
    if ((!addBtn && !lineBtn) || busy) return;

    busy = true;
    showError('');
    try {
      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';
        await post('/cart/add.js', {
          items: [{ id: Number(addBtn.getAttribute('data-add')), quantity: 1 }],
        });
      } else {
        lineBtn.disabled = true;
        await post('/cart/change.js', {
          line: Number(lineBtn.getAttribute('data-line')),
          quantity: Number(lineBtn.getAttribute('data-qty')),
        });
      }
      await refreshSection();
    } catch (err) {
      showError(err.message);
      await refreshSection().catch(() => {});
    } finally {
      busy = false;
    }
  });

  applyFilter();
})();
